/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/gitlab.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { RpcStatus } from '../models'
// @ts-ignore
import type { TrackerGetIssueDevInfoResponse } from '../models'
// @ts-ignore
import type { TrackerGetPipelineSummaryResponse } from '../models'
// @ts-ignore
import type { TrackerListBranchesResponse } from '../models'
// @ts-ignore
import type { TrackerListMergeRequestsResponse } from '../models'
// @ts-ignore
import type { TrackerListPipelinesResponse } from '../models'
// @ts-ignore
import type { TrackerListReleasesResponse } from '../models'
/**
 * GitLabServiceApi - axios parameter creator
 */
export const GitLabServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary The development part of a task card in one request.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceGetIssueDevInfo: async (
      issueId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueId' is not null or undefined
      assertParamExists('gitLabServiceGetIssueDevInfo', 'issueId', issueId)
      const localVarPath = `/api/v1/tracker/issues/{issueId}/dev-info`.replace(
        '{issueId}',
        encodeURIComponent(String(issueId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary The pipelines screen: the current run of every service branch behind a project or one epic.
     * @param {string} projectId
     * @param {string} [epicId] Narrow it down to one epic and everything under it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceGetPipelineSummary: async (
      projectId: string,
      epicId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists('gitLabServiceGetPipelineSummary', 'projectId', projectId)
      const localVarPath = `/api/v1/tracker/projects/{projectId}/pipeline-summary`.replace(
        '{projectId}',
        encodeURIComponent(String(projectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (epicId !== undefined) {
        localVarQueryParameter['epicId'] = epicId
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Branches of one repository, freshest first. Read live from GitLab: a stand is raised for a branch nobody has linked to a task yet just as often, and the mirror knows only the linked ones.
     * @param {string} [gitlabProjectPath]
     * @param {string} [search] Substring of the branch name; empty means the freshest ones.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListBranches: async (
      gitlabProjectPath?: string,
      search?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/gitlab/branches`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (gitlabProjectPath !== undefined) {
        localVarQueryParameter['gitlabProjectPath'] = gitlabProjectPath
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Merge requests across projects, newest first. Open ones by default: the question the review screen asks is what is waiting, not what happened.
     * @param {string} [gitlabProjectPath]
     * @param {Array<string>} [states] States to keep: opened, merged, closed, locked. Empty means opened only.
     * @param {string} [authorUsername]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListMergeRequests: async (
      gitlabProjectPath?: string,
      states?: Array<string>,
      authorUsername?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/merge-requests`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (gitlabProjectPath !== undefined) {
        localVarQueryParameter['gitlabProjectPath'] = gitlabProjectPath
      }

      if (states) {
        localVarQueryParameter['states'] = states
      }

      if (authorUsername !== undefined) {
        localVarQueryParameter['authorUsername'] = authorUsername
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Pipelines across projects: the monitoring screen. Without a filter it returns the latest runs of every project the webhook reports on.
     * @param {string} [gitlabProjectPath] Project path in GitLab: vinprop/backend/tracker. Empty means all of them.
     * @param {string} [ref] Branch or tag. Empty means all of them.
     * @param {Array<string>} [statuses] GitLab statuses to keep: running, failed, success. Empty means all.
     * @param {boolean} [onlyWithIssue] Only runs tied to a task.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListPipelines: async (
      gitlabProjectPath?: string,
      ref?: string,
      statuses?: Array<string>,
      onlyWithIssue?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/pipelines`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (gitlabProjectPath !== undefined) {
        localVarQueryParameter['gitlabProjectPath'] = gitlabProjectPath
      }

      if (ref !== undefined) {
        localVarQueryParameter['ref'] = ref
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses
      }

      if (onlyWithIssue !== undefined) {
        localVarQueryParameter['onlyWithIssue'] = onlyWithIssue
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Releases of the repositories the tracker listens to. In this project a release is a semver tag on master, so tags are what gets read — including the ones somebody cut by hand, which the action log never saw.
     * @param {string} [gitlabProjectPath] Empty means every repository with a live webhook.
     * @param {number} [perRepository] How many releases to keep per repository; 0 means the service default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListReleases: async (
      gitlabProjectPath?: string,
      perRepository?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/gitlab/releases`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (gitlabProjectPath !== undefined) {
        localVarQueryParameter['gitlabProjectPath'] = gitlabProjectPath
      }

      if (perRepository !== undefined) {
        localVarQueryParameter['perRepository'] = perRepository
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * GitLabServiceApi - functional programming interface
 */
export const GitLabServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = GitLabServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary The development part of a task card in one request.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gitLabServiceGetIssueDevInfo(
      issueId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerGetIssueDevInfoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gitLabServiceGetIssueDevInfo(
        issueId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GitLabServiceApi.gitLabServiceGetIssueDevInfo']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary The pipelines screen: the current run of every service branch behind a project or one epic.
     * @param {string} projectId
     * @param {string} [epicId] Narrow it down to one epic and everything under it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gitLabServiceGetPipelineSummary(
      projectId: string,
      epicId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerGetPipelineSummaryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gitLabServiceGetPipelineSummary(
        projectId,
        epicId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GitLabServiceApi.gitLabServiceGetPipelineSummary']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Branches of one repository, freshest first. Read live from GitLab: a stand is raised for a branch nobody has linked to a task yet just as often, and the mirror knows only the linked ones.
     * @param {string} [gitlabProjectPath]
     * @param {string} [search] Substring of the branch name; empty means the freshest ones.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gitLabServiceListBranches(
      gitlabProjectPath?: string,
      search?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListBranchesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gitLabServiceListBranches(
        gitlabProjectPath,
        search,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GitLabServiceApi.gitLabServiceListBranches']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Merge requests across projects, newest first. Open ones by default: the question the review screen asks is what is waiting, not what happened.
     * @param {string} [gitlabProjectPath]
     * @param {Array<string>} [states] States to keep: opened, merged, closed, locked. Empty means opened only.
     * @param {string} [authorUsername]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gitLabServiceListMergeRequests(
      gitlabProjectPath?: string,
      states?: Array<string>,
      authorUsername?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListMergeRequestsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gitLabServiceListMergeRequests(
        gitlabProjectPath,
        states,
        authorUsername,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GitLabServiceApi.gitLabServiceListMergeRequests']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Pipelines across projects: the monitoring screen. Without a filter it returns the latest runs of every project the webhook reports on.
     * @param {string} [gitlabProjectPath] Project path in GitLab: vinprop/backend/tracker. Empty means all of them.
     * @param {string} [ref] Branch or tag. Empty means all of them.
     * @param {Array<string>} [statuses] GitLab statuses to keep: running, failed, success. Empty means all.
     * @param {boolean} [onlyWithIssue] Only runs tied to a task.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gitLabServiceListPipelines(
      gitlabProjectPath?: string,
      ref?: string,
      statuses?: Array<string>,
      onlyWithIssue?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListPipelinesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gitLabServiceListPipelines(
        gitlabProjectPath,
        ref,
        statuses,
        onlyWithIssue,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GitLabServiceApi.gitLabServiceListPipelines']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Releases of the repositories the tracker listens to. In this project a release is a semver tag on master, so tags are what gets read — including the ones somebody cut by hand, which the action log never saw.
     * @param {string} [gitlabProjectPath] Empty means every repository with a live webhook.
     * @param {number} [perRepository] How many releases to keep per repository; 0 means the service default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gitLabServiceListReleases(
      gitlabProjectPath?: string,
      perRepository?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListReleasesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.gitLabServiceListReleases(
        gitlabProjectPath,
        perRepository,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['GitLabServiceApi.gitLabServiceListReleases']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * GitLabServiceApi - factory interface
 */
export const GitLabServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = GitLabServiceApiFp(configuration)
  return {
    /**
     *
     * @summary The development part of a task card in one request.
     * @param {string} issueId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceGetIssueDevInfo(
      issueId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerGetIssueDevInfoResponse> {
      return localVarFp
        .gitLabServiceGetIssueDevInfo(issueId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary The pipelines screen: the current run of every service branch behind a project or one epic.
     * @param {string} projectId
     * @param {string} [epicId] Narrow it down to one epic and everything under it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceGetPipelineSummary(
      projectId: string,
      epicId?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerGetPipelineSummaryResponse> {
      return localVarFp
        .gitLabServiceGetPipelineSummary(projectId, epicId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Branches of one repository, freshest first. Read live from GitLab: a stand is raised for a branch nobody has linked to a task yet just as often, and the mirror knows only the linked ones.
     * @param {string} [gitlabProjectPath]
     * @param {string} [search] Substring of the branch name; empty means the freshest ones.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListBranches(
      gitlabProjectPath?: string,
      search?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListBranchesResponse> {
      return localVarFp
        .gitLabServiceListBranches(gitlabProjectPath, search, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Merge requests across projects, newest first. Open ones by default: the question the review screen asks is what is waiting, not what happened.
     * @param {string} [gitlabProjectPath]
     * @param {Array<string>} [states] States to keep: opened, merged, closed, locked. Empty means opened only.
     * @param {string} [authorUsername]
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListMergeRequests(
      gitlabProjectPath?: string,
      states?: Array<string>,
      authorUsername?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListMergeRequestsResponse> {
      return localVarFp
        .gitLabServiceListMergeRequests(
          gitlabProjectPath,
          states,
          authorUsername,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Pipelines across projects: the monitoring screen. Without a filter it returns the latest runs of every project the webhook reports on.
     * @param {string} [gitlabProjectPath] Project path in GitLab: vinprop/backend/tracker. Empty means all of them.
     * @param {string} [ref] Branch or tag. Empty means all of them.
     * @param {Array<string>} [statuses] GitLab statuses to keep: running, failed, success. Empty means all.
     * @param {boolean} [onlyWithIssue] Only runs tied to a task.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListPipelines(
      gitlabProjectPath?: string,
      ref?: string,
      statuses?: Array<string>,
      onlyWithIssue?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListPipelinesResponse> {
      return localVarFp
        .gitLabServiceListPipelines(
          gitlabProjectPath,
          ref,
          statuses,
          onlyWithIssue,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Releases of the repositories the tracker listens to. In this project a release is a semver tag on master, so tags are what gets read — including the ones somebody cut by hand, which the action log never saw.
     * @param {string} [gitlabProjectPath] Empty means every repository with a live webhook.
     * @param {number} [perRepository] How many releases to keep per repository; 0 means the service default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gitLabServiceListReleases(
      gitlabProjectPath?: string,
      perRepository?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListReleasesResponse> {
      return localVarFp
        .gitLabServiceListReleases(gitlabProjectPath, perRepository, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * GitLabServiceApi - object-oriented interface
 */
export class GitLabServiceApi extends BaseAPI {
  /**
   *
   * @summary The development part of a task card in one request.
   * @param {string} issueId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gitLabServiceGetIssueDevInfo(issueId: string, options?: RawAxiosRequestConfig) {
    return GitLabServiceApiFp(this.configuration)
      .gitLabServiceGetIssueDevInfo(issueId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary The pipelines screen: the current run of every service branch behind a project or one epic.
   * @param {string} projectId
   * @param {string} [epicId] Narrow it down to one epic and everything under it.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gitLabServiceGetPipelineSummary(
    projectId: string,
    epicId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return GitLabServiceApiFp(this.configuration)
      .gitLabServiceGetPipelineSummary(projectId, epicId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Branches of one repository, freshest first. Read live from GitLab: a stand is raised for a branch nobody has linked to a task yet just as often, and the mirror knows only the linked ones.
   * @param {string} [gitlabProjectPath]
   * @param {string} [search] Substring of the branch name; empty means the freshest ones.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gitLabServiceListBranches(
    gitlabProjectPath?: string,
    search?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return GitLabServiceApiFp(this.configuration)
      .gitLabServiceListBranches(gitlabProjectPath, search, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Merge requests across projects, newest first. Open ones by default: the question the review screen asks is what is waiting, not what happened.
   * @param {string} [gitlabProjectPath]
   * @param {Array<string>} [states] States to keep: opened, merged, closed, locked. Empty means opened only.
   * @param {string} [authorUsername]
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gitLabServiceListMergeRequests(
    gitlabProjectPath?: string,
    states?: Array<string>,
    authorUsername?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return GitLabServiceApiFp(this.configuration)
      .gitLabServiceListMergeRequests(
        gitlabProjectPath,
        states,
        authorUsername,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Pipelines across projects: the monitoring screen. Without a filter it returns the latest runs of every project the webhook reports on.
   * @param {string} [gitlabProjectPath] Project path in GitLab: vinprop/backend/tracker. Empty means all of them.
   * @param {string} [ref] Branch or tag. Empty means all of them.
   * @param {Array<string>} [statuses] GitLab statuses to keep: running, failed, success. Empty means all.
   * @param {boolean} [onlyWithIssue] Only runs tied to a task.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gitLabServiceListPipelines(
    gitlabProjectPath?: string,
    ref?: string,
    statuses?: Array<string>,
    onlyWithIssue?: boolean,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return GitLabServiceApiFp(this.configuration)
      .gitLabServiceListPipelines(
        gitlabProjectPath,
        ref,
        statuses,
        onlyWithIssue,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Releases of the repositories the tracker listens to. In this project a release is a semver tag on master, so tags are what gets read — including the ones somebody cut by hand, which the action log never saw.
   * @param {string} [gitlabProjectPath] Empty means every repository with a live webhook.
   * @param {number} [perRepository] How many releases to keep per repository; 0 means the service default.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public gitLabServiceListReleases(
    gitlabProjectPath?: string,
    perRepository?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return GitLabServiceApiFp(this.configuration)
      .gitLabServiceListReleases(gitlabProjectPath, perRepository, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
